import { z } from 'zod'

import {
  isCNPJ,
  isValidBrazilEmailFormat
} from '@/global/utils/validation-schema'

const companyDataFormSchema = z
  .object({
    responsibleName: z
      .string({ message: 'Nome inválido' })
      .min(3, 'O nome deve conter ao menos 3 letras'),
    telefone: z
      .string({ message: 'Número de telefone inválido' })
      .min(11, 'O número de telefone está incompleto'),
    responsibleEmail: z
      .string()
      .email('E-mail inválido')
      .refine(isValidBrazilEmailFormat, { message: 'E-mail inválido' }),
    cnpj: z
      .string({ message: 'CNPJ Inválido' })
      .refine(isCNPJ, { message: 'CNPJ Inválido' }),
    companyName: z
      .string({ message: 'Nome inválido' })
      .min(3, 'O nome deve conter ao menos 3 letras'),
    city: z.string().min(1),
    findOutAliceSelect: z.string().optional(),
    socialMediaSelect: z.string().optional(),
    otherField: z.string().optional()
  })
  .refine(
    data => {
      if (
        data.findOutAliceSelect !== 'Outros (especifique)' &&
        data.findOutAliceSelect !== 'Redes sociais'
      ) {
        return !!data.findOutAliceSelect
      }
      return true
    },
    { path: ['findOutAlice'], message: 'Esse campo é obrigatório' }
  )
  .refine(
    data => {
      if (data.findOutAliceSelect === 'Outros (especifique)') {
        return !!data.otherField
      }
      return true
    },
    { path: ['otherField'], message: 'Esse campo é obrigatório' }
  )
  .refine(
    data => {
      if (data.findOutAliceSelect === 'Redes sociais') {
        return !!data.socialMediaSelect
      }
      return true
    },
    { path: ['socialMedia'], message: 'Esse campo é obrigatório' }
  )

export { companyDataFormSchema }
